import { render, staticRenderFns } from "./LawAuthoritySubCategoryList.vue?vue&type=template&id=950ef274&"
import script from "./LawAuthoritySubCategoryList.vue?vue&type=script&lang=js&"
export * from "./LawAuthoritySubCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./LawAuthoritySubCategoryList.vue?vue&type=style&index=0&id=950ef274&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports